// News Rio logo: brutalist italic "R" inside red block + heavy condensed wordmark
export const RioLogo = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 ${className}`}
    data-testid="rio-logo"
    aria-label="News Rio"
  >
    <span
      className="inline-flex items-center justify-center"
      style={{
        width: "2.25rem",
        height: "2.25rem",
        backgroundColor: "var(--rio-accent)",
      }}
    >
      <span
        style={{
          fontFamily: "'Anton', sans-serif",
          fontStyle: "italic",
          fontSize: "1.6rem",
          color: "#0A0A0A",
          lineHeight: 1,
          transform: "translateY(1px)",
        }}
      >
        R
      </span>
    </span>
    <span
      className="font-display"
      style={{
        fontFamily: "'Anton', sans-serif",
        fontSize: "1.75rem",
        letterSpacing: "-0.01em",
        lineHeight: 1,
        color: "var(--rio-text)",
        textTransform: "uppercase",
      }}
    >
      News Rio
    </span>
  </span>
);

export default RioLogo;
